import axiosAdmin from "../../api/axiosAdmin";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const DJsPage = () => {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    try {
      const response = await axiosAdmin.get("/dj/all");

      setRequests(response.data);
    } catch (error) {
      console.error("Error fetching requests:", error);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Djs</h1>

      {/* Desktop table */}
      <table className="hidden md:table w-full border-collapse">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-2 border">Name</th>
            <th className="p-2 border w-1/4">Username</th>
            <th className="p-2 border">Email</th>
            <th className="p-2 border w-1/6">Status</th>
            <th className="p-2 border">Price (PLN)</th>
            <th className="p-2 border">Place</th>
            <th className="p-2 border">Stripe Account</th>
            <th className="p-2 border">Actions</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((request) => (
            <tr key={request.id} className="hover:bg-gray-50">
              <td className="p-2 border">{request.name}</td>
              <td className="p-2 border">{request.username}</td>
              <td className="p-2 border">{request.email}</td>
              <td className="p-2 border flex items-center gap-2">
                {request.online ? "Online" : "Offline"}
                <span
                  className={`inline-block w-3 h-3 rounded-full ${
                    request.online ? "bg-green-500" : "bg-red-500"
                  }`}
                ></span>
              </td>
              <td className="p-2 border">
                {request.currentPrice ? request.currentPrice : "N/A"}
              </td>
              <td className="p-2 border">
                {request.place ? request.place.name : "N/A"}
              </td>
              <td className="p-2 border text-center">
                {request.stripeAccountId}
              </td>
              <td className="p-2 border text-center">
                <Link
                  to={`/admin-panel/djs/${request.id}`}
                  className="text-blue-500"
                >
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Mobile cards */}
      <div className="md:hidden space-y-4 py-4">
        {requests.map((request) => (
          <div
            key={request.id}
            className="w-full border rounded-lg p-4 shadow-md bg-white"
          >
            <div className="font-bold text-lg">{request.name}</div>
            <div className="text-sm text-gray-500 flex items-center gap-2">
              Status: {request.online ? "Online" : "Offline"}{" "}
              <span
                className={`inline-block w-3 h-3 rounded-full ${
                  request.online ? "bg-green-500" : "bg-red-500"
                }`}
              ></span>
            </div>
            {request.online && (
              <>
                <div className="text-sm text-gray-500">
                  Price: {request.currentPrice ? request.currentPrice : "N/A"}
                </div>
                <div className="text-sm text-gray-500">
                  Place: {request.place ? request.place.name : "N/A"}
                </div>
              </>
            )}

            <Link
              to={`/admin-panel/djs/${request.id}`}
              className="text-blue-500 mt-2 inline-block"
            >
              View
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
export default DJsPage;
